import React, { useCallback } from 'react';

import { IconClose } from '@/components/icons/IconClose';
import { useOrderContext, useOrderDispatch } from '@/components/modals/SubmitOrder/helpers';
import { Modal, ModalBody } from '@/components/proxy/reactstrap/Modal';

import { ConfirmationBanner } from '../ShippingStep/components/AddressBook/components/ConfirmationBanner';

import { Props } from './types';

import styles from './CancellationModal.module.scss';

export const CancellationModal = ({ submitModal }: Props) => {
  const state = useOrderContext();
  const dispatch = useOrderDispatch();

  const closeModal = useCallback(() => {
    dispatch({
      type: 'UPDATE',
      payload: {
        isCancellationModalOpened: false,
      },
    });
  }, [dispatch]);

  return (
    <Modal
      backdrop="static"
      fullscreen
      isOpen={state.isCancellationModalOpened}
      keyboard={false}
      toggle={closeModal}
    >
      <IconClose
        aria-label="Close Modal"
        classes={{ container: styles.close }}
        onClick={closeModal}
      />
      <ModalBody>
        <ConfirmationBanner
          cancelTitle="Return to order"
          classes={{ wrapper: styles.wrapper, title: styles.title }}
          onCancelButtonClick={closeModal}
          onSubmitButtonClick={submitModal}
          subTitle="Any changes you have made will not be saved once you exit. If you cancel this process
              now you must start from the beginning when you come back to this order."
          submitTitle="I understand, Cancel this order"
          title="Are you sure want to cancel?"
        />
      </ModalBody>
    </Modal>
  );
};
